export const STH_WENT_WRONG = "Something went wrong";
export const EXTERNAL_RESPONSE = "external_response";
